import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-iframe-modal-render',
    templateUrl: './iframe-modal-render.component.html',
    styleUrls: ['./iframe-modal-render.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose]
})
export class IframeModalRenderComponent {

  public safeUrl: SafeResourceUrl;
  public cargando = true;

  constructor(
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<IframeModalRenderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { url: string }
  ) {
    this.safeUrl = this.getSafeUrl(this.data.url);
  }

  close(): void {
    this.dialogRef.close();
  }

  onIframeLoad() {
    this.cargando = false;
  }

  onIframeError(event: Event) {
    this.cargando = false;
  }

  getSafeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
